import { Box, Button, Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import Image from 'artkive/components/Image'
import { HeroPrice, KeepsakeAlsoLove, KeepsakeSection } from 'artkive/pages/Keepsakes'

import ValueLabelComponent from './ValueLabelComponent'

export const Wrapper = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  overflowX: 'hidden',
  backgroundColor: theme.colors.sky[100],
}))

export const LookInsideBox = styled('div')(({ theme }) => ({
  backgroundColor: theme.colors.sky[100],
  position: 'absolute',
  bottom: 0,
  right: 0,
  clipPath: 'polygon(100% 0, 100% 100%, 0 100%)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '110px',
  width: '140px',
  [theme.breakpoints.up('md')]: {
    height: '149px',
    width: '190px',
  },
  [theme.breakpoints.up('xl')]: {
    marginRight: '120px',
  },
}))

export const LookInsideSpaceBox = styled('div')(({ theme }) => ({
  display: 'none',
  width: '121px',
  height: '149px',
  backgroundColor: theme.colors.sky[100],
  position: 'absolute',
  right: 0,
  bottom: 0,
  [theme.breakpoints.up('xl')]: {
    display: 'block',
  },
}))

export const LookInsideButton = styled(Button)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  bottom: 0,
  padding: '16px',
  color: theme.colors.blue[900],
  fontWeight: 700,
  fontSize: '0.875rem',
  lineHeight: 1.4,
  textAlign: 'right',
  '&:hover, &:focus': {
    backgroundColor: 'transparent',
    outline: 'none',
    border: 'none',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1rem',
    lineHeight: 1.6,
    padding: '20px 30px',
  },
}))

export const PriceInfoBox = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  gap: '8px',
  marginTop: '24px',
  [theme.breakpoints.up('md')]: {
    marginTop: '16px',
    alignItems: 'flex-start',
  },
}))

export const CountdownBox = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '32px',
  [theme.breakpoints.up('md')]: {
    marginBottom: 0,
    justifyContent: 'flex-start',
  },
}))

export const StartingPrice = styled(HeroPrice)({
  margin: '0 4px',
})

export const PricingText = styled(Box)(({ theme: { breakpoints } }) => ({
  [breakpoints.up('md')]: {
    maxWidth: 750,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}))

export const PriceLabel = styled(ValueLabelComponent)(({ theme: { breakpoints } }) => ({
  [breakpoints.up('md')]: {
    maxWidth: 320,
  },
}))

export const SliderBox = styled('div')(({ theme: { breakpoints } }) => ({
  padding: '0 8px',
  margin: '40px 0',
  [breakpoints.up('md')]: {
    padding: '0 100px',
    margin: '32px 0 44px',
  },
}))

export const TestimonialSection = withStyles(({ breakpoints }) => ({
  root: {
    [breakpoints.up('md')]: {
      paddingTop: 0,
    },
  },
}))(KeepsakeSection)

export const FeaturesTitle = styled(Typography)(({ theme: { breakpoints } }) => ({
  [breakpoints.up('md')]: {
    maxWidth: 454,
    margin: '0 auto',
  },
}))

export const FeaturesSprite = styled(Image)({
  position: 'absolute',
  top: -50,
  right: -31,
  width: 64,
  transform: 'scaleX(-1)',
  zIndex: 1,
})

// Placed so the dots stay at least 12px clear of the last card's title on phones.
export const FeaturesBubbles = styled(Image)({
  position: 'absolute',
  bottom: 112,
  left: -24,
  width: 80,
  transform: 'scaleX(-1)',
  zIndex: 0,
})

export const AlsoLove = withStyles({
  lines: {
    top: 270,
    right: 'auto',
    bottom: 'auto',
    left: 248,
  },
})(KeepsakeAlsoLove)
